import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { map, Observable, take } from 'rxjs';

import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { CartConnector } from '@b2b/features/cart/core/cart.connector';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { CartEntry } from '@b2b/features/cart/utilities/cart.model';
import { TranslateModule } from '@ngx-translate/core';
import { CartProductComponent } from '@b2b/components/cart/cart-product/cart-product.component';
import { OrderService } from '@b2b/features/order/core/order.service';

@Component({
  selector: 'cart-furnisher',
  imports: [CommonModule, RouterModule, AccordionComponent, CartProductComponent, TranslateModule],
  templateUrl: './cart-furnisher.component.html',
  styleUrl: './cart-furnisher.component.scss',
})
export class CartFurnisherComponent implements OnInit {
  private readonly cartService = inject(CartService);
  private readonly orderService = inject(OrderService);
  private readonly cartConnector = inject(CartConnector);

  @Input() disabledItems: boolean = false;
  @Input() onCheckout: boolean = false;

  accordionState$ = this.cartService.accordionState$;

  credit$: Observable<string | null> = this.cartConnector.getAvailableCredit();

  entries$ = this.cartService.takeCart().pipe(map(cart => cart.entries));

  ngOnInit(): void {
    if (this.onCheckout) {
      this.entries$ = this.orderService.getCurrentOrder().pipe(
        map(cart => {
          if (!cart.currentOrder.data) return [];
          return cart.currentOrder.data.flatMap(order => order.entries as CartEntry[]);
        }),
      );
    }
  }

  onAccordionClick = (event: MouseEvent, id: string) => {
    if (!this.accordionState$) return;

    this.accordionState$.pipe(take(1)).subscribe(state => {
      const newState = new Map(state);
      const currentValue = newState.get(id) ?? false;
      newState.set(id, !currentValue);
      this.cartService.updateAccordionState(newState);
    });
  };
}
